import { createSelector, createFeatureSelector } from '@ngrx/store';
import { PayrollUIState } from 'app/main/payroll/payroll.types';
import { State, RouteState } from 'app/main/payroll/reducers';

export const getRouteState = createFeatureSelector<State, RouteState>(
  'payroll'
);

export const selectPayrollUIState = createSelector(
  getRouteState,
  ({ ui }): PayrollUIState => ui
);

export const selectSelectedTab = createSelector(
  selectPayrollUIState,
  ({ selectedTab }) => selectedTab
);

export const selectSelectedYears = createSelector(
  selectPayrollUIState,
  ({ selectedYears }) => selectedYears
);

export const selectSelectdFilter = createSelector(
  selectPayrollUIState,
  ({ selectedFilter, selectedFilterKeys }) => {
   return {
    selectedFilter,
    selectedFilterKeys
   };
  }
);

export const selectSelectdFilterSynthese = createSelector(
  selectPayrollUIState,
  ({ selectedFilterSynthese }) => selectedFilterSynthese
);

export const selectViewTypeSynthese = createSelector(
  selectPayrollUIState,
  ({ selectViewTypeSynthese }) => selectViewTypeSynthese
);
